import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';
import { CommonModule, Location } from '@angular/common'; // Import Location
import { DataService } from '@/app/services/shared/stage2.service';
import { FormsModule } from '@angular/forms';
import { NgToastService } from 'ng-angular-popup';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { Subscription } from 'rxjs';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { GetProjectIdService } from '@/app/services/getProjectId.service';
import {
  PlanStep,
  ProgressService,
} from '@/app/services/shared/progress.service';
import { TabbedScrollerComponent } from '../../tabbed-scroller/tabbed-scroller.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { DialogUtilityService } from '@/app/services/utility/dialog-utility.service';
import { ProgressBarComponent } from '../../progress-bar/progress-bar.component';
@Component({
  selector: 'app-racimatrix',
  standalone: true,
  imports: [
    MatIcon,
    FormsModule,
    CommonModule,
    NgxPageScrollModule,
    MatFormFieldModule,
    MatSelectModule,
    ProgressBarComponent,
  ],
  templateUrl: './raci-matrix.component.html',
  styleUrl: './raci-matrix.component.css',
})
export class RaciMatrixComponent implements OnInit {
  @Output() dataChange = new EventEmitter<any>();
  private subscriptions: Subscription = new Subscription();
  items: any[] = []; // Declare 'items' array
  index = 0; // Initialize 'index'

  isLoadingNext = false;
  isLoadingSave = false;
  stakeholders: any[] = [];
  selectedSection = 'section1';
  stage2Progress: any;
  constructor(
    private router: Router,
    private location: Location,
    private dataService: DataService,
    private toast: NgToastService,
    private projectsService: ProjectsService,
    private getProjectIdService: GetProjectIdService,
    private progressService: ProgressService,
    private TabbedScrollerComponent: TabbedScrollerComponent,
    private dialogService: DialogUtilityService
  ) {} // Inject Location service

  ngOnInit() {
    this.getProjectDetail();
    this.dataService.getWorkPackageItems().subscribe((data) => {
      if (Array.isArray(data)) {
        this.items = data;
      } else {
        console.error('work_package_items is not an array:', data);
        this.items = []; // Set to an empty array if invalid
      }
    });
    this.progressService.progress2$.subscribe((value) => {
      this.stage2Progress = value;
    });
  }

  addStakeholder(newStakeholder: string, child: any, actor: string) {
    console.log(child);

    if (newStakeholder.trim()) {
      const exists = this.stakeholders.some(
        (s) => s.stake_holder === newStakeholder
      );

      if (!exists) {
        const projectId = this.getProjectIdService.getProjectId();
        if (!projectId) {
          this.toast.danger('Project ID not found', 'DANGER', 4000);
          return;
        }
        const data = {
          stake_holder: newStakeholder,
        };
        this.projectsService
          .updateProjectStakeHolder(data, +projectId)
          .subscribe({
            next: (response) => {
              if (response) {
                this.stakeholders.push({
                  stake_holder: response?.data?.stake_holder,
                });
              }
            },
            error: (error) => {
              if (error) {
                console.log(error);
              }
            },
          });
        // Add new stakeholder to the list
        setTimeout(() => {
          const inputElement =
            document.querySelector<HTMLInputElement>('.search-input');
          if (inputElement) {
            inputElement.value = ''; // Clear manually
            inputElement.blur(); // Remove focus
          }
        }, 100);
      }

      // Set the newly added stakeholder as selected
      if (actor === 'reponsible') {
        child.responsible = newStakeholder;
      } else if (actor === 'accountable') {
        child.accountable = newStakeholder;
      } else if (actor === 'consulted') {
        child.consulted = newStakeholder;
      } else if (actor === 'informed') {
        child.informed = newStakeholder;
      }
    }
  }

  // Navigate back to the previous page
  navigatetoPreviousPage() {
    this.location.back(); // Use Location service to go back
  }

  handleSubmit(action: string) {
    if (this.dataService.getData('work_package_items').length > 0) {
      const dataToSubmit = new FormData();
      const projectId = this.getProjectIdService.getProjectId();
      if (!projectId) {
        this.toast.danger('Project ID not found', 'DANGER', 4000);
        return;
      }

      dataToSubmit.append('project_id', projectId);
      this.items.forEach((item: any, index) => {
        if (item.children.length > 0) {
          item.children.forEach((child: any) => {
            dataToSubmit.append(`work_packages[${index}][id]`, child.id);
            dataToSubmit.append(
              `work_packages[${index}][actor]`,
              child.responsible
            );
            dataToSubmit.append(
              `work_packages[${index}][accountable]`,
              child.accountable
            );
            dataToSubmit.append(
              `work_packages[${index}][consulted]`,
              child.consulted
            );
            dataToSubmit.append(
              `work_packages[${index}][informed]`,
              child.informed
            );
            index++;
          });
        } else {
          dataToSubmit.append(`work_packages[${index}][id]`, item.id);
          dataToSubmit.append(
            `work_packages[${index}][responsible]`,
            item.responsible
          );
          dataToSubmit.append(
            `work_packages[${index}][accountable]`,
            item.accountable
          );
          dataToSubmit.append(
            `work_packages[${index}][consulted]`,
            item.consulted
          );
          dataToSubmit.append(
            `work_packages[${index}][informed]`,
            item.informed
          );
        }
      });

      if (action === 'next') {
        this.isLoadingNext = true;
      } else {
        this.isLoadingSave = true;
      }

      this.projectsService.createWorkBreakDownStandard(dataToSubmit).subscribe({
        next: (response: any) => {
          console.log('Responsibility Matrix added successfully:', response);
          this.toast.success('Section saved successfully', 'SUCCESS', 4000);

          this.progressService.updateStepProgress(
            PlanStep.WorkPackagesRaci,
            true
          );
          const stages = {
            stage1: true,
            stage2: true,
            stage3: false,
          };
          localStorage.setItem('stages', JSON.stringify(stages));
          this.dataChange.emit(stages);
          if (action === 'next') {
            this.isLoadingNext = false;
          } else {
            this.isLoadingSave = false;
          }

          if (action === 'next') {
            this.TabbedScrollerComponent.nextStep();
          }
        },
        error: (error: any) => {
          if (action === 'next') {
            this.isLoadingNext = false;
          } else {
            this.isLoadingSave = false;
          }

          console.error('Login failed:', error);
          this.toast.danger(error.error.message, 'DANGER', 4000);
        },
      });
    }
  }
  handleBack() {
    this.TabbedScrollerComponent.previousStep();
    this.handleSubmit('save');
  }

  getProjectDetail() {
    this.projectsService.getProjectDetails().subscribe({
      next: (response: any) => {
        this.stakeholders = response?.stake_holders;
      },
      error: (error: any) => {
        console.error('error:', error);
      },
    });
  }
  closeDialog() {
    this.dialogService.closeProjectPlanDialog();
    this.handleSubmit('save');
  }
  onKeyDown(event: KeyboardEvent) {
    if (event.key === ' ') {
      event.stopPropagation(); // Prevent Mat-Select from handling Space
    }
  }
}
